<template>
  <div>
    <p class="point-name">{{when}}の{{name}}</p>
    <p class="point-num">
      <span class="point-num-val">{{pointVal}}</span>pt
    </p>
  </div>
</template>

<script>

export default {
  name: "PointLabelLarge",
  data: () => ({
  }),
  methods: {
  },
  components: {
  },
  props: ['when', 'name', 'pointVal']
};

</script>

<style scoped>
.vertical-no-padding-col {
  padding: 0 12px;
}
p {
  color: #fff;
  font-weight: bold;
  margin: 0;
}
.point-name {
  font-size: 1.5em;
}
.point-num {
  font-size: 2em;
}
.point-num-val {
  font-size: 2em;
}
@media screen and (max-width: 350px) {
}
@media screen and (min-width: 351px) and (max-width: 768px) {
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
}
@media screen and (min-width: 1024px) {
}
</style>
